import axios from 'axios'


const kullaniciCreate = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/user/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default kullaniciCreate;